import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    job: PropTypes.shape({
      title: PropTypes.string,
    }),
  })
);
